import createIcon from '../../createIcon';

/**
 * @component @name CropLandscape
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgNUg1QzMuOSA1IDMgNS45IDMgN1YxN0MzIDE4LjEgMy45IDE5IDUgMTlIMTlDMjAuMSAxOSAyMSAxOC4xIDIxIDE3VjdDMjEgNS45IDIwLjEgNSAxOSA1Wk0xOSAxN0g1VjdIMTlWMTdaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const CropLandscape = createIcon('CropLandscape', [
  [
    'path',
    {
      d: 'M19 5H5C3.9 5 3 5.9 3 7V17C3 18.1 3.9 19 5 19H19C20.1 19 21 18.1 21 17V7C21 5.9 20.1 5 19 5ZM19 17H5V7H19V17Z',
      key: '1i8n59',
    },
  ],
]);

export default CropLandscape;
